import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractDynamicComponent } from '../popups/abstract-dynamic.component';
import { Animations } from '../../animations/animations';
import { DbService } from '../../services/db-service';
import { LoaderComponent } from '../shared/loader/loader.component';
import { ToastService } from '../../services/toast.service';
import { ToastType } from '../../../enums/toast-type.enum';

import { FileDownloadService } from '../../services/file-download.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-onboarding-popup',
    standalone: true,
    imports: [LoaderComponent],
    templateUrl: './onboarding-popup.component.html',
    styleUrl: './onboarding-popup.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [Animations.modalPop],
})
export class OnboardingPopupComponent extends AbstractDynamicComponent<void> {
    public loading = false;

    constructor(
        private readonly dbService: DbService,
        private readonly toastService: ToastService,
        private readonly fileDownloadService: FileDownloadService
    ) {
        super();
    }

    public onClose(): void {
        this.close();
    }

    public downloadCSVTemplate(): void {
        this.loading = true;

        this.dbService
            .downloadCSVTemplate()
            .pipe(finalize(() => (this.loading = false)))
            .subscribe({
                next: (res) => {
                    this.fileDownloadService.downloadCSV(res.body as Blob, 'Sapphire AVS – Address Book Template.csv');
                },
                error: () => {
                    this.toastService.showToast('Unable to download CSV template. Please try again.', ToastType.Error);
                },
            });
    }
}
